import Loading from '@components/shared/Loading';
import { useCurrentReport, useCurrentReports } from '../../hooks/useReports';
import { Alert } from '@mui/material';
import { useCpgAIInsights } from '@features/ai-insights';
import { useCurrentCampaign } from '../../hooks/useCampaign';
import { RealTimeOptimization } from './RealTimeOptimization';

export const RealTimeOptimizationContainer = () => {
  const { report, loading } = useCurrentReport();
  const { reports, loading: loadingAllReports } = useCurrentReports();
  const { campaign, isFetching: loadingCampaign } = useCurrentCampaign();
  const { cpgAiInsights } = useCpgAIInsights(
    report ?? null,
    'top-bottom-performers'
  );

  if (loading || loadingAllReports || loadingCampaign) return <Loading />;

  if (!report || !campaign)
    return <Alert severity="error">Error loading campaign data.</Alert>;

  return (
    <RealTimeOptimization
      report={report}
      campaignName={campaign.name}
      reports={reports}
      aiInsights={cpgAiInsights}
    />
  );
};
